import type { FieldDef } from '../types';

const fieldLabel = (field: FieldDef) =>
  field.required ? `${field.label || field.key} *` : field.label || field.key;

export default fieldLabel;
